import gql from 'graphql-tag';

export default gql`
  query getAllFeaturedCollections {
    getAllFeaturedCollections {
      description
      id
      name
      studySets {
        id
        title
      }
    }
  }
`;
